export function isCypressTest() {
  return Boolean(typeof window !== 'undefined' && window.Cypress);
}
